import { render, staticRenderFns } from "./romaKingdom.vue?vue&type=template&id=a7b8682e&scoped=true"
import script from "./romaKingdom.vue?vue&type=script&lang=js"
export * from "./romaKingdom.vue?vue&type=script&lang=js"
import style0 from "./romaKingdom.vue?vue&type=style&index=0&id=a7b8682e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b8682e",
  null
  
)

export default component.exports